module.exports = __webpack_public_path__ + "img/related-materials.68c3cdce.svg";